var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('img',{attrs:{"id":"logo","src":require("../assets/svg/TSNY_Logo_Full.svg"),"alt":""},on:{"click":_vm.toLogin}})])}
var staticRenderFns = []

export { render, staticRenderFns }